// // src/components/admin/layout/Sidebar.jsx
// import React from "react";
// import { NavLink, useNavigate } from "react-router-dom";
// import "./Sidebar.css";

// const Sidebar = () => {
//   const navigate = useNavigate();
//   const adminName = localStorage.getItem("adminName") || "Admin User";
//   const adminEmail = localStorage.getItem("adminEmail") || "admin";
//   const avatarLetter = adminName[0].toUpperCase();

//   const handleLogout = () => {
//     localStorage.clear();
//     navigate("/login");
//   };

//   return (
//     <div className="admin-sidebar-new">
//       {/* Header */}
//       <div className="sidebar-header">
//         <h2 className="sidebar-title">Admin Panel</h2>
//       </div>

//       {/* User Profile */}
//       <div className="sidebar-user">
//         <div className="user-avatar">{avatarLetter}</div>
//         <div className="user-info">
//           <h3 className="user-name">{adminName}</h3>
//           <p className="user-role">{adminEmail.split('@')[0]}</p>
//         </div>
//       </div>

//       {/* Navigation Menu */}
//       <nav className="sidebar-nav">
//         <NavLink 
//           to="/admin/dashboardsettings" 
//           end
//           className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}
//         >
//           <span className="nav-icon">📊</span>
//           <span className="nav-label">Dashboard</span>
//         </NavLink>

//         <NavLink 
//           to="/admin/homesettings"
//           className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}
//         >
//           <span className="nav-icon">🏠</span>
//           <span className="nav-label">Home Settings</span>
//         </NavLink>

//          <NavLink 
//           to="/admin/aboutsections"
//           className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}
//         >
//            <span className="nav-icon">ℹ️</span>
//           <span className="nav-label">About</span>
//         </NavLink>

//           <NavLink 
//           to="/admin/specialization"
//           className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}
//         >
//            <span className="nav-icon">⭐</span>
//           <span className="nav-label">Specials</span>
//         </NavLink>

//         {/* <a href="#" className="nav-item">
//           <span className="nav-icon">⭐</span>
//           <span className="nav-label">Specials</span>
//         </a> */}

//         <NavLink 
//           to="/admin/servicesections"
//           className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}
//         >
//           <span className="nav-icon">💼</span>
//           <span className="nav-label">Services</span>
    
//         </NavLink>
      
//         {/* <a href="#" className="nav-item">
//           <span className="nav-icon">📰</span>
//           <span className="nav-label">Blog</span>
//         </a>

//         <a href="#" className="nav-item">
//           <span className="nav-icon">💬</span>
//           <span className="nav-label">Testimonials</span>
//         </a> */}

//         <NavLink 
//           to="/admin/contactsections"
//           className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}
//         >
//           <span className="nav-icon">📞</span>
//           <span className="nav-label">Contact</span>
    
//         </NavLink>

//          <NavLink 
//           to="/admin/portfolios"
//           className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}
//         >
//          <span className="nav-icon">📂</span>
//           <span className="nav-label">Portfolio</span>
//         </NavLink>

//       <NavLink 
//           to="/admin/clients"
//           className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}
//         >
//           <span className="nav-icon">💼</span>
//           <span className="nav-label">Our Clients</span>
    
//         </NavLink>

//       <NavLink 
//           to="/admin/cancellationpolicy"
//           className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}
//         >
//           <span className="nav-icon">📝</span>
//           <span className="nav-label">Cancellation Policy</span>
    
//         </NavLink>

//           <NavLink 
//           to="/admin/shippingpolicy"
//           className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}
//         >
//           <span className="nav-icon">📝</span>
//           <span className="nav-label">Shipping Policy</span>
    
//         </NavLink>

//           <NavLink 
//           to="/admin/termsconditions"
//           className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}
//         >
//           <span className="nav-icon">📝</span>
//           <span className="nav-label">Terms Conditions</span>
    
//         </NavLink>


//          {/* <a href="#" className="nav-item">
//           <span className="nav-icon">🖼️</span>
//           <span className="nav-label">Gallery</span>
//         </a> */}

//          <div className="nav-divider"></div>
//         <NavLink 
//           to="/admin/examresult"
//           className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}
//         >
//           <span className="nav-icon">📝</span>
//           <span className="nav-label">Exam Result</span>
//         </NavLink>

//         <NavLink 
//           to="/admin/getresult"
//           className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}
//         >
//           <span className="nav-icon">📋</span>
//           <span className="nav-label">Get Result</span>
//         </NavLink>

//         <NavLink 
//           to="/admin/questions"
//           className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}
//         >
//           <span className="nav-icon">❓</span>
//           <span className="nav-label">Questions</span>
//         </NavLink> 

//       </nav>
//     </div>
//   );
// };

// export default Sidebar;

// src/components/admin/layout/Sidebar.jsx
import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import "./Sidebar.css";

const Sidebar = () => {
 // const navigate = useNavigate();
  const [isSidebarOpen, setIsSidebarOpen] = useState(window.innerWidth > 575); // Open on desktop by default
  const adminName = localStorage.getItem("adminName") || "Admin User";
  const adminEmail = localStorage.getItem("adminEmail") || "admin";
  const avatarLetter = adminName[0].toUpperCase();

  // const handleLogout = () => {
  //   localStorage.clear();
  //   navigate("/login");
  // };

  const toggleSidebar = () => {
    console.log("Toggle clicked, current state:", isSidebarOpen);
    setIsSidebarOpen(!isSidebarOpen);
  };

  const closeSidebar = () => {
    if (window.innerWidth <= 575) {
      setIsSidebarOpen(false);
    }
  };

  return (
    <>
      {/* Toggle Button */}
      <button 
        className={`sidebar-toggle ${isSidebarOpen ? 'open' : ''}`}
        onClick={toggleSidebar}
        aria-label="Toggle menu"
      >
        <span className="toggle-icon">{isSidebarOpen ? '✕' : '☰'}</span>
      </button>

      {/* Overlay for mobile */}
      {isSidebarOpen && window.innerWidth <= 575 && (
        <div className="sidebar-overlay" onClick={closeSidebar} />
      )}

      {/* Sidebar */}
      <div className={`admin-sidebar-new ${isSidebarOpen ? 'expanded' : 'collapsed'}`}>
        {/* Header */}
        <div className="sidebar-header">
          <h2 className="sidebar-title">Admin Panel</h2>
        </div>

        {/* User Profile */}
        <div className="sidebar-user">
          <div className="user-avatar">{avatarLetter}</div>
          <div className="user-info">
            <h3 className="user-name">{adminName}</h3>
            <p className="user-role">{adminEmail.split('@')[0]}</p>
          </div>
        </div>

        {/* Navigation Menu */}
        <nav className="sidebar-nav">
          <NavLink 
            to="/admin/dashboardsettings" 
            end
            className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}
            onClick={closeSidebar}
          >
            <span className="nav-icon">📊</span>
            <span className="nav-label">Dashboard</span>
          </NavLink>

          <NavLink 
            to="/admin/homesettings"
            className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}
            onClick={closeSidebar}
          >
            <span className="nav-icon">🏠</span>
            <span className="nav-label">Home Settings</span>
          </NavLink>

          <NavLink 
            to="/admin/aboutsections"
            className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}
            onClick={closeSidebar}
          >
            <span className="nav-icon">ℹ️</span>
            <span className="nav-label">About</span>
          </NavLink>

          <NavLink 
            to="/admin/specialization"
            className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}
            onClick={closeSidebar}
          >
            <span className="nav-icon">⭐</span>
            <span className="nav-label">Specials</span>
          </NavLink>

          <NavLink 
            to="/admin/servicesections"
            className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}
            onClick={closeSidebar}
          >
            <span className="nav-icon">💼</span>
            <span className="nav-label">Services</span>
          </NavLink>

          <NavLink 
            to="/admin/contactsections"
            className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}
            onClick={closeSidebar}
          >
            <span className="nav-icon">📞</span>
            <span className="nav-label">Contact</span>
          </NavLink>

          <NavLink 
            to="/admin/portfolios"
            className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}
            onClick={closeSidebar}
          >
            <span className="nav-icon">📂</span>
            <span className="nav-label">Portfolio</span>
          </NavLink>
           <NavLink 
            to="/admin/gallery"
            className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}
            onClick={closeSidebar}
          >
            <span className="nav-icon"> 🖼️</span>
            <span className="nav-label">Gallery</span>
          </NavLink>

          <NavLink 
            to="/admin/clients"
            className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}
            onClick={closeSidebar}
          >
            <span className="nav-icon">💼</span>
            <span className="nav-label">Our Clients</span>
          </NavLink>

          <NavLink 
            to="/admin/cancellationpolicy"
            className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}
            onClick={closeSidebar}
          >
            <span className="nav-icon">📝</span>
            <span className="nav-label">Cancellation Policy</span>
          </NavLink>

          <NavLink 
            to="/admin/shippingpolicy"
            className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}
            onClick={closeSidebar}
          >
            <span className="nav-icon">📝</span>
            <span className="nav-label">Shipping Policy</span>
          </NavLink>

          <NavLink 
            to="/admin/termsconditions"
            className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}
            onClick={closeSidebar}
          >
            <span className="nav-icon">📝</span>
            <span className="nav-label">Terms Conditions</span>
          </NavLink>

          <div className="nav-divider"></div>
          
          <NavLink 
            to="/admin/examresult"
            className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}
            onClick={closeSidebar}
          >
            <span className="nav-icon">📝</span>
            <span className="nav-label">Exam Result</span>
          </NavLink>

          <NavLink 
            to="/admin/getresult"
            className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}
            onClick={closeSidebar}
          >
            <span className="nav-icon">📋</span>
            <span className="nav-label">Get Result</span>
          </NavLink>

          <NavLink 
            to="/admin/questions"
            className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}
            onClick={closeSidebar}
          >
            <span className="nav-icon">❓</span>
            <span className="nav-label">Questions</span>
          </NavLink>
        </nav>
      </div>
    </>
  );
};

export default Sidebar;